'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosWorld = function IoIosWorld(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m0 31.1c8.2 0 14.9-6.6 14.9-14.9s-6.7-14.9-14.9-14.9c-8.3 0-15 6.6-15 14.9s6.7 14.9 15 14.9z m5.1-21.5c0.5 1.8 0.7 3.8 0.8 6h-5.3v-5.3c1.5-0.1 3-0.4 4.5-0.7z m-4.5-7c1.5 0.5 3.2 2.7 4.2 5.9-1.3 0.3-2.8 0.4-4.2 0.5v-6.4z m-5.6 5.9c1-3.3 2.8-5.4 4.3-5.9v6.4c-1.5-0.1-2.9-0.2-4.3-0.5z m14.7-1.9c-1.2 0.6-2.4 1.2-3.7 1.6-0.7-2.3-1.7-4.1-2.8-5.3 2.5 0.6 4.7 1.9 6.5 3.7z m-2.6 9c-0.1-2.3-0.4-4.4-0.8-6.3 1.5-0.4 2.9-1.1 4.2-1.8 1.8 2.2 3 5 3.1 8.1h-6.5z m-13.1 0c0.1-2.2 0.2-4.2 0.7-6 1.5 0.4 3.1 0.6 4.6 0.7v5.3h-5.3z m11.9 1.2c-0.1 2.2-0.3 4.2-0.8 6-1.5-0.4-3-0.6-4.5-0.7v-5.3h5.3z m-11.2 6c-0.5-1.8-0.6-3.8-0.7-6h5.3v5.3c-1.5 0.1-3.1 0.3-4.6 0.7z m4.6 7c-1.5-0.5-3.3-2.6-4.3-5.9 1.4-0.3 2.8-0.4 4.3-0.5v6.4z m3.9-0.3c1.1-1.2 2.1-3 2.8-5.3 1.3 0.4 2.5 0.9 3.7 1.5-1.8 1.8-4 3.2-6.5 3.8z m-6.5-26.6c-1.1 1.2-2.1 3.1-2.8 5.3-1.2-0.4-2.5-0.9-3.7-1.5 1.7-1.8 4-3.2 6.5-3.8z m9.6 20.2c0.4-1.9 0.7-4 0.8-6.3h6.5c-0.1 3.1-1.3 5.9-3.1 8.1-1.3-0.7-2.7-1.4-4.2-1.8z m-5.7 0.3c1.4 0.1 2.9 0.2 4.2 0.5-1 3.3-2.7 5.4-4.2 5.9v-6.4z m-7-14.1c-0.4 1.9-0.8 4-0.8 6.3h-6.5c0.1-3.1 1.3-5.9 3.1-8.1 1.3 0.7 2.7 1.4 4.2 1.8z m-0.8 7.5c0 2.3 0.3 4.4 0.7 6.3-1.4 0.4-2.8 1.1-4.1 1.8-1.8-2.2-3-5-3.1-8.1h6.5z m-2.6 8.9c1.2-0.6 2.5-1.1 3.7-1.5 0.7 2.2 1.7 4.1 2.8 5.3-2.5-0.6-4.8-2-6.5-3.8z' })
        )
    );
};

exports.default = IoIosWorld;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-world.js
// module id = 2805
// module chunks = 168707334958949